import GeneralInfoTemplate from "../../../templates/admin/generalInfo";

const GeneralInfoScreen = () => {
  return <GeneralInfoTemplate />;
};

export default GeneralInfoScreen;
